import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListPlanes from "./ListPlanes";
import PlanesEdit from "./PlanesEdit";
import PlanesNew from "./PlanesNew";
import Busqueda from "./Busqueda";

export default class AdmPlanes extends React.Component{

    render(){
        return(
            <div>
                <Routes>
                    <Route path="" element={<ListPlanes/>}/>
                    <Route path="Editar/:id" element={<PlanesEdit/>}/>
                    <Route path="Nuevo" element={<PlanesNew/>}/>
                    <Route path="Busqueda" element={<Busqueda/>}/>
                </Routes>
            </div>
        );
    }
}